import { actions } from '.';
import { ofType } from 'redux-observable';
import { map, switchMap, debounceTime } from 'rxjs/operators';
import { of } from 'rxjs';
import webApi from '../../../Lib/WebApi';
import { addErrorNotice, callApi, catchWithAuthErrors } from '../../Helpers/rxjsHelpers';
import moment from 'moment';
import { DEBOUNCE_TIME_FOR_KEYSTROKE_IN_MS } from 'Lib/Rxjs/constants';

export const get = (action$) => {
  return action$.pipe(
    ofType(actions.searchGet.toString()),
    debounceTime(DEBOUNCE_TIME_FOR_KEYSTROKE_IN_MS),
    switchMap(({ payload: { limit, search, searchId } = {} }) => {
      let dateSampledWithFallback = [
        { operator: '>=', value: moment().add(-30, 'day').format('YYYY-MM-DD') },
        { operator: '<=', value: moment().format('YYYY-MM-DD') },
      ];

      return callApi(
        webApi.worksheets.query.get({
          limit,
          search,
          dateSampledWithFallback,
          expandBody: false,
        })
      ).pipe(
        map((response) =>
          actions.searchGetResolve({ worksheets: { worksheets: response.Body.Worksheets, search } || null, searchId })
        ),
        catchWithAuthErrors((err) =>
          of(actions.searchGetReject({ searchId }), addErrorNotice('Failed to get worksheets.', err))
        )
      );
    })
  );
};

export const getAdvanced = (action$, state$) => {
  return action$.pipe(
    ofType(actions.advancedSearchGet.toString()),
    switchMap(({ payload: { limit, searchId } = {} }) => {
      let dateSampledWithFallback = [
        { operator: '>=', value: moment().add(-30, 'day').format('YYYY-MM-DD') },
        { operator: '<=', value: moment().format('YYYY-MM-DD') },
      ];
      let worksheetStatus = null;
      let worksheetTypeId = null;
      let search = state$.value.searchWorksheets.advancedSearch;
      let filter = state$.value.searchWorksheets.filter;
      // Clear date sampled if search is for all time
      if (filter && !filter.onlyRecentTests) dateSampledWithFallback = null;
      if (filter && filter.testStatus) worksheetStatus = filter.testStatus;
      if (filter && filter.testMethods) {
        worksheetTypeId = filter.testMethods.map(({ value }) => value);
      }
      if (filter && !filter.onlyRecentTests && (search === null || search === '')) {
        return of(actions.advancedSearchGetResolve({ advancedWorksheets: null, searchId }));
      } else {
        return callApi(
          webApi.worksheets.query.get({
            limit,
            search,
            dateSampledWithFallback,
            expandBody: false,
            worksheetTypeId,
            worksheetStatus,
          })
        ).pipe(
          map((response) =>
            actions.advancedSearchGetResolve({
              advancedWorksheets: { worksheets: response.Body.Worksheets, search } || null,
              searchId,
            })
          ),
          catchWithAuthErrors((err) =>
            of(actions.advancedSearchGetReject({ searchId }), addErrorNotice('Failed to get worksheets.', err))
          )
        );
      }
    })
  );
};

export const getRecent = (action$) => {
  return action$.pipe(
    ofType(actions.recentGet.toString()),
    switchMap(({ payload: { limit } = {} }) => {
      return callApi(
        webApi.worksheets.query.get({
          limit,
          orderBy: 'LastModifiedByCurrentUser desc',
          onlyIncludeWorksheetsAccessedByUser: true,
          expandBody: false,
        })
      ).pipe(
        map((response) => actions.recentGetResolve({ recentWorksheets: response.Body.Worksheets || null })),
        catchWithAuthErrors((err) =>
          of(actions.recentGetReject(), addErrorNotice('Failed to get recent worksheets.', err))
        )
      );
    })
  );
};
